<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '60vw' }" header="Preview Assessment Answers" :modal="true" class="p-fluid dialog-header" :breakpoints="{ '1199px': '80vw', '767px': '90vw' }" @hide="$emit('hide-dialog', true)">
            <div>
                <DefaultLoader v-if="loading" />
                <div v-else class="card my-3 border-1">
                    <ul class="list-none p-0 m-0">
                        <li v-for="attribute in props.previewData" class="border-bottom-1 surface-border flex justify-content-start gap-3 p-3" :key="attribute.id">
                            <div class="text-900 font-medium">{{ attribute.label }} :</div>
                            <div class="font-bold">
                                {{ attribute.answer }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';

const props = defineProps({
    previewData: {
        type: Array,
        required: true,
    },
    loading: Boolean,
});

const visible = ref(true);
const dots = ref('.');

onMounted(() => {
    showLoadingDots();
});

const showLoadingDots = () => {
    // Function to update loader with dots
    function updateLoader() {
        dots.value += '.';
        if (dots.value.length > 3) {
            dots.value = '.';
        }
    }
    if (props.loading) {
        // Update loader every 500 milliseconds
        setInterval(updateLoader, 500);
    }
};
</script>
